import { c as _c } from "react/compiler-runtime";
import useCurrency from '@/contexts/i18nContext/hooks/useCurrency';
import useTranslate from '@/contexts/i18nContext/hooks/useTranslate';
import { capitalize, formatPrice } from '@winelidays/wld-tsx-2/utils';
const SegmentationLine = t0 => {
    const $ = _c(16);
    const { participantsRange, price } = t0;
    const translate = useTranslate();
    const { symbol: currencySymbol } = useCurrency();
    let t1;
    if ($[0] !== participantsRange.lower || $[1] !== participantsRange.upper || $[2] !== translate) {
        t1 = !participantsRange.upper || participantsRange.upper === participantsRange.lower ? translate("practical.participants.exact", {
            number: participantsRange.lower,
            long: false
        }) : translate("practical.participants.min_max", {
            min: participantsRange.lower,
            max: participantsRange.upper,
            long: false
        });
        $[0] = participantsRange.lower;
        $[1] = participantsRange.upper;
        $[2] = translate;
        $[3] = t1;
    }
    else {
        t1 = $[3];
    }
    const guestRange = t1;
    let t2;
    if ($[4] !== currencySymbol || $[5] !== price || $[6] !== translate) {
        t2 = price ? translate("messages.price_with_currency", {
            price: formatPrice(price),
            currencySymbol
        }) : capitalize(translate("practical.call_price.free"));
        $[4] = currencySymbol;
        $[5] = price;
        $[6] = translate;
        $[7] = t2;
    }
    else {
        t2 = $[7];
    }
    const pricePerGuest = t2;
    const t3 = `${participantsRange.lower}`;
    let t4;
    if ($[8] !== guestRange) {
        t4 = <th className="p-2 pl-0 pr-4 text-left font-semibold text-md text-gray-400" scope="row">{guestRange}</th>;
        $[8] = guestRange;
        $[9] = t4;
    }
    else {
        t4 = $[9];
    }
    let t5;
    if ($[10] !== pricePerGuest) {
        t5 = <td className="p-2 pl-0 pr-4 text-left font-semibold text-md">{pricePerGuest}</td>;
        $[10] = pricePerGuest;
        $[11] = t5;
    }
    else {
        t5 = $[11];
    }
    let t6;
    if ($[12] !== t3 || $[13] !== t4 || $[14] !== t5) {
        t6 = <><tr key={t3} className="border-b border-gray-120 last:border-0">{t4}{t5}</tr></>;
        $[12] = t3;
        $[13] = t4;
        $[14] = t5;
        $[15] = t6;
    }
    else {
        t6 = $[15];
    }
    return t6;
};
export default SegmentationLine;
